import { jsx as _jsx } from "react/jsx-runtime";
import { nullsToUndefined } from "../../../../../../../helpers/null.js";
import * as S from "./styled.js";
const ButtonViewMore = ({ link , content  })=>/*#__PURE__*/ _jsx(S.ButtonBox, {
        "data-testid": "ButtonViewMore",
        className: "button-view-more",
        children: /*#__PURE__*/ _jsx("a", {
            ...nullsToUndefined(link),
            children: content
        })
    });
export default ButtonViewMore;

//# sourceMappingURL=index.js.map